import React, { Component } from "react";
import { Link } from "react-router-dom";

class PrepareButton extends Component {
  render() {
    const { pdcId, label } = this.props;

    return (
      <Link to={`/activite/prepare/${pdcId}`}>
        <span className={`p-btn p-btn-blue "p-mrg-left-s`}>{label}</span>
      </Link>
    );
  }
}

export default PrepareButton;



// WEBPACK FOOTER //
// src/components/activite/buttons/PrepareButton.js